export const FEATUREFLAG_KEY = process.env.GATSBY_LAUNCHDARKLY_KEY || "";
